import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <rect width="40" height="40" rx="12" fill="#1E2621" />
    <path d="M11 23.5a9 9 0 0 1 18 0z" fill="#C86D51" />
    <path d="M8 27.5c4-3 8 3 12 0s8-3 12 0" fill="none" stroke="#F4F1EA" strokeWidth="2.2" strokeLinecap="round" />
    <path d="M11 32c3-2.2 6 2.2 9 0s6-2.2 9 0" fill="none" stroke="#8F9E8B" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ light = false, onClick }) => (
  <Link to="/" onClick={onClick} className="group flex items-center gap-3" data-testid="header-logo-link">
    <span className="transition-transform duration-500 group-hover:-rotate-6">
      <LogoMark />
    </span>
    <span className={`font-serif-display text-2xl leading-none tracking-tight ${light ? "text-[#F4F1EA]" : "text-[#1E2621]"}`}>
      Surgevity<span className="italic text-[#C86D51]"> Solutions</span>
    </span>
  </Link>
);
